
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frequently-asked-questions/[category]/[slug]",
      function () {
        return require("private-next-pages/frequently-asked-questions/[category]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frequently-asked-questions/[category]/[slug]"])
      });
    }
  